import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

const red = '#bb0000';
const grey ='#a2afb9';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    fontSize: 22,
    textAlign:'center',
    backgroundColor :grey,
    color: '#ffffff'
  },
  input: {
    display: 'none',
  },
});
class IfYouDontHaveGmail extends Component {
  handleOnClick = () => {
    this.props.clickFunc()
  }

  render(){
  const { classes } = this.props;
  return (
    <div>
      <Button
        onClick={this.handleOnClick}
        variant="contained"
        color={red}
        className={classes.button}
      >
      Guest Login
      </Button>
    </div>
  );
}
}


IfYouDontHaveGmail.propTypes = {
  classes: PropTypes.object.isRequired,
  clickFunc: PropTypes.func.isRequired
};

export default withStyles(styles)(IfYouDontHaveGmail);



// WEBPACK FOOTER //
// ./src/components/general/IfYouDontHaveGmail.js